<template>
    <v-app class="app" id="app">
        <div>
            <router-view
                @setAccount="updateAccount($event)"
                :account="account"
            ></router-view>
            <app-snackbar></app-snackbar>

<!--            <app-confirm-dialog-->
<!--                title="Are you still there?"-->
<!--                submitButtonTitle="I'm Still Here"-->
<!--                :open="youStillThereDialogOpen"-->
<!--                @close="confirmStillThere"-->
<!--                confirm-delete-->
<!--                @confirm="confirmStillThere"-->
<!--            >-->
<!--                This window will close in {{secondsLeft}} seconds.-->
<!--            </app-confirm-dialog>-->
        </div>
    </v-app>
</template>

<script>
// import SidebarLeft from "@/components/SidebarLeft";
// import NavbarTop from "@/components/NavbarTop";
import Highcharts from 'highcharts'
import {swayThemes} from "@/config/themes"
import {logout, getOrgFromBrowserStorage, getUserFromBrowserStorage, initializePendo} from '@/services/userService'
import {SET_ACCOUNT, SET_ORGANIZATION} from "@/store/mutation-types";

import AppSnackbar from "@/components/AppSnackbar";
import {getOrganizationForSessionStorage} from "@/services/organization.service";
import httpService from "@/services/httpService";

// import '@/styles/pdf.css'
// import '@/styles/general.css'

const timeoutWarningDelay = 18; //if no one touches screen for 18 minutes, popup will show asking if still there
const timeoutNowDelay = .9; //dialog will stay open for .9 minutes

// Set timeout variables.
const timeoutWarning = 1000 * 60 * timeoutWarningDelay; // Display warning in 19 minutes.
const timeoutNow = 1000 * 60 * timeoutNowDelay; // Warning has been shown, give the user 30 seconds to interact

export default {
    name: 'App',
    components: {
        // 'sidebar-left': SidebarLeft,
        // 'navbar-top': NavbarTop,
        AppSnackbar
    },

    data: () => ({
        theme: 'light',
        account: null,
        youStillThereDialogOpen: false,
        secondsLeft: null,
    }),
    created() {
        this.setTheme();

        const favicon = document.getElementById("favicon");
        const origin = window.location.origin;
        
        favicon.href = `${origin}/sway-favicon.ico`;
        window.document.title = 'Sway'

        document.addEventListener('visibilitychange', this.handleVisibility, false)
    },
    async mounted() {
        let account = await getUserFromBrowserStorage();
        if (account){
            // Prefer the URL's orgId over localStorage. When a new tab is opened
            // pointed at a specific org (e.g. from the Super Admin Organizations
            // page), localStorage still holds the previously-active org id —
            // hydrating the store with it would show stale org context (Dashboard
            // org id, "Viewing as Internal Sway Admin" banner, org name under the
            // username) until the next navigation triggered a switch.
            const urlOrgId = this.$route?.query?.orgId;
            let lastUsedOrgId = urlOrgId || localStorage.getItem("selectedOrganizationId");
            if (!lastUsedOrgId || lastUsedOrgId === "undefined" || lastUsedOrgId === "null"){
                // No org context to restore — clear auth state and bounce to /login.
                logout();
                return;
            }
            else {
                let organization = await getOrganizationForSessionStorage(lastUsedOrgId);
                sessionStorage.setItem("selectedOrganization", JSON.stringify(organization))
                sessionStorage.setItem("selectedOrganizationId", organization.id)
                localStorage.setItem("selectedOrganizationId", organization.id)
                httpService.setSelectedOrgId(organization.id);

                this.$store.commit(SET_ORGANIZATION, organization)

                // Pendo's SDK doesn't carry across page refreshes — each page load is
                // a new session. Re-initialize here using the identity we just
                // rehydrated from storage so tracking resumes for refresh / new-tab
                // / deep-link loads without going through the login flow.
                initializePendo(account, organization);
            }
        }
        this.$store.commit(SET_ACCOUNT, account)
        this.account = account ? account : 'null';
    },
    updated() {
        // let account = getUser();
        // this.account = account ? account : 'null';
    },

    methods: {
        updateAccount(account) {
            this.account = account
            // console.log('SEETING ACCOUNT', event)
        },
        onLightDarkChange() {
            this.$vuetify.theme.dark = !this.$vuetify.theme.dark
        },
        setTheme() {
            let newTheme = swayThemes;

            let darkKeys = Object.keys(newTheme.dark)
            darkKeys.forEach(key => {
                this.$vuetify.theme.themes.dark[key] = newTheme.dark[key]
            })
            let lightKeys = Object.keys(newTheme.light)
            lightKeys.forEach(key => {
                this.$vuetify.theme.themes.light[key] = newTheme.light[key]
            });
        },
        handleVisibility (e) { // HACK: use localStorage to set selected organization in new tabs
            // HACK: the better approach is to add orgId to all href links
            if (document.visibilityState === 'hidden') {
                // do nothing
            } else { 
                let selectedOrgId = sessionStorage.getItem("selectedOrganizationId")
                
                if (selectedOrgId) {
                    localStorage.setItem("selectedOrganizationId", selectedOrgId);
                }
            }
        }
    },
};
</script>
<style scoped>


#app {
    /* font-family: proxima-nova,Helvetica Neue,Helvetica,Arial,sans-serif; */
    display: flex;
    background-color: #f5f5f5;
}

.sidebar-container {
    height: 100vh;
    position: -webkit-sticky;
    position: sticky;
    width: 240px
}

.main-content {
    height: calc(100vh - 80px);
    width: calc(100vw - 240px);
    padding: 0 20px;
    overflow-y: scroll;
}

/* .main-content::-webkit-scrollbar-track {
  background: rgb(255, 0, 0);
} */

.top-bar {
    height: 80px;
    width: calc(100vw - 240px)
}

.theme-picker {
    position: fixed;
    bottom: 10px;
    right: 20px;
    /*height: 20px;*/
    /*width: 20px;*/
    /*background-color: red;*/
}
</style>

<style lang="scss">
/* ============================================
   SWAY UNIVERSITY INSPIRED STYLING
   Modern, clean design with Inter font
   ============================================ */

/* Global font and base styles */
html, body, .v-application {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1F2937 !important;
}

/* Headings */
h1, h2, h3, h4, h5, h6 {
  font-family: 'Inter', sans-serif !important;
  font-weight: 600 !important;
  color: #1F2937;
}

h1 { font-size: 2rem; }
h2 { font-size: 1.5rem; }
h3 { font-size: 1.25rem; }
h4 { font-size: 1.125rem; }

/* Overlay z-index fixes */
.v-overlay {
  z-index: 2400 !important;
}

.v-overlay__content {
  z-index: 2401 !important;
}

.v-menu > .v-overlay__content {
  z-index: 2401 !important;
}

/* ============================================
   BUTTONS - Modern rounded style
   ============================================ */
.v-btn {
  text-transform: none !important;
  letter-spacing: -0.01em !important;
  font-weight: 500 !important;
  font-family: 'Inter', sans-serif !important;
  border-radius: 8px !important;
  transition: all 0.2s ease !important;
}

.v-btn--variant-flat {
  box-shadow: none !important;
}

.v-btn--variant-flat:hover {
  box-shadow: 0 4px 12px rgba(51, 211, 255, 0.25) !important;
  transform: translateY(-1px);
}

.v-btn--variant-elevated {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
}

.v-btn--variant-outlined {
  border-width: 1.5px !important;
}

.v-btn .v-icon {
  font-size: 1.125rem;
}

/* Primary buttons */
.v-btn.bg-primary,
.v-btn[style*="background-color: rgb(var(--v-theme-primary))"] {
  color: white !important;
}

/* ============================================
   CARDS - Clean with subtle shadows
   ============================================ */
.v-card {
  border-radius: 12px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.06) !important;
  border: 1px solid #E5E7EB !important;
  overflow: hidden;
}

.v-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.v-card-title {
  font-size: 1.125rem !important;
  font-weight: 600 !important;
  font-family: 'Inter', sans-serif !important;
  color: #1F2937 !important;
}

.v-card-text {
  color: #4B5563 !important;
  font-size: 0.9375rem;
}

/* ============================================
   FORM INPUTS - Modern rounded style
   ============================================ */
.v-field--variant-outlined {
  border-radius: 8px !important;
}

.v-field__outline {
  --v-field-border-opacity: 0.2;
}

.v-field--focused .v-field__outline {
  --v-field-border-opacity: 1;
}

.v-input--density-compact .v-field__input {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  min-height: 44px !important;
}

.v-select .v-field__input {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.v-field__input {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
  font-family: 'Inter', sans-serif !important;
}

.v-label {
  font-family: 'Inter', sans-serif !important;
  font-weight: 500 !important;
  color: #374151 !important;
}

/* ============================================
   CHIPS - Rounded pill style
   ============================================ */
.v-chip {
  font-weight: 500 !important;
  font-family: 'Inter', sans-serif !important;
  border-radius: 9999px !important;
}

/* ============================================
   TABS - Clean underline style
   ============================================ */
.v-tab {
  text-transform: none !important;
  letter-spacing: -0.01em !important;
  font-weight: 500 !important;
  font-family: 'Inter', sans-serif !important;
}

/* ============================================
   DATA TABLES - Clean with hover states
   ============================================ */
.v-data-table {
  border-radius: 12px !important;
  overflow: hidden;
  font-family: 'Inter', sans-serif !important;
}

.v-data-table-header th {
  font-weight: 600 !important;
  font-size: 0.75rem !important;
  text-transform: uppercase !important;
  letter-spacing: 0.05em !important;
  color: #6B7280 !important;
  background-color: #F9FAFB !important;
}

.v-data-table tbody tr:hover {
  background-color: #F9FAFB !important;
}

/* ============================================
   LIST ITEMS
   ============================================ */
.v-list-item {
  min-height: 44px !important;
  border-radius: 8px !important;
}

.v-list-item:hover {
  background-color: #F3F4F6 !important;
}

.v-list-item-title {
  font-size: 0.9375rem !important;
  font-family: 'Inter', sans-serif !important;
}

/* ============================================
   DIALOGS
   ============================================ */
.dialog-card {
  border-radius: 16px !important;
}

.dialog-card .v-container {
  padding: 0 !important;
}

.dialog-card .v-row {
  margin: 0 -8px !important;
}

.dialog-card .v-col {
  padding: 4px 8px !important;
}

.dialog-overlay {
  backdrop-filter: blur(4px);
}

/* ============================================
   FORM SPACING
   ============================================ */
.v-input {
  margin-bottom: 0 !important;
}

.v-input--density-compact {
  margin-bottom: 8px !important;
}

.v-checkbox .v-selection-control {
  min-height: 32px !important;
}

.v-card-text .v-container {
  padding: 0 16px !important;
}

.v-row + .v-row {
  margin-top: 0 !important;
}

/* ============================================
   DIVIDERS
   ============================================ */
.v-divider {
  border-color: #E5E7EB !important;
}

/* ============================================
   ALERTS & SNACKBARS
   ============================================ */
.v-snackbar__content {
  font-family: 'Inter', sans-serif !important;
}

.v-alert {
  border-radius: 12px !important;
}

/* ============================================
   HIGHCHARTS FONT
   ============================================ */
.highcharts-root {
  font-family: 'Inter', sans-serif !important;
}
</style>
